import { createOidcApiInstance } from '@/utils/api/axiosInstance'
import { handleApiStatus } from '@/utils/api/handleAPI'

import * as oidc from '@/api-generator/oidc/index'

const registerApi = createOidcApiInstance(oidc.RegisterApi)

export const requestNewAccount = async (reqData: oidc.RequestNewAccountApplyRq) => {
  const res = await handleApiStatus(() => registerApi.postRegisterRequestnewaccountapply(reqData))
  return res
}

export const validateVerificationCode = async (reqData: oidc.VerifyEmailVerificationCodeRq) => {
  const res = await handleApiStatus(() => registerApi.postRegisterVerifyemailverificationcode(reqData))
  return res
}

export const registerSystemAccount = async (reqData: oidc.SystemRq) => {
  const res = await handleApiStatus(() => registerApi.postRegisterSystem(reqData))
  return res
}

export const validateInvitationCode = async (
  invitationCode: string,
  invitationEmail: string,
  invitationChecksum: string
) => {
  const res = await handleApiStatus(() =>
    registerApi.getRegisterValidinvitationcode(invitationCode, invitationEmail, invitationChecksum)
  )
  return res
}

export const requestForgotPassword = async (reqData: oidc.RequestForgotPasswordApplyRq) => {
  const res = await handleApiStatus(() => registerApi.postRegisterRequestforgotpasswordapply(reqData))
  return res
}

export const resetPassword = async (reqData: oidc.ResetPasswordRq) => {
  const res = await handleApiStatus(() => registerApi.postRegisterResetpassword(reqData))
  return res
}
